import type { ReactNode } from 'react';

// Descrições de card usam **negrito** e *itálico* como convenção (ver
// CardTemplateModal.tsx, ex: "**Candidato:** {{nome_candidato}}") e
// também podem conter uma URL crua (ex: link do evento no Google
// Calendar — ver eleveia-api apps/boards/services/sync.py::
// _build_lead_card_content, bloco "VISITA AGENDADA"). Não é markdown
// completo de propósito — sem dependência nova para suportar sintaxe
// que não é usada aqui (sem listas, tabelas, headings etc.).
const URL_SPLIT_REGEX = /(https?:\/\/[^\s]+)/g;
const URL_MATCH_REGEX = /^https?:\/\/[^\s]+$/;

function renderWithLinks(text: string, keyPrefix: string): ReactNode[] {
  return text
    .split(URL_SPLIT_REGEX)
    .filter((segment) => segment.length > 0)
    .map((segment, i) =>
      URL_MATCH_REGEX.test(segment) ? (
        <a
          key={`${keyPrefix}-${i}`}
          href={segment}
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-600 hover:underline"
        >
          {segment}
        </a>
      ) : (
        <span key={`${keyPrefix}-${i}`}>{segment}</span>
      ),
    );
}

export function renderBoldText(text: string): ReactNode[] {
  // Alternativa de **negrito** vem antes de *itálico* na regex — a
  // engine tenta a primeira alternativa em cada posição, então
  // "**bold**" nunca é lido como duas marcações de itálico coladas.
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={i}>{renderWithLinks(part.slice(2, -2), `b${i}`)}</strong>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={i}>{renderWithLinks(part.slice(1, -1), `i${i}`)}</em>;
    }
    return <span key={i}>{renderWithLinks(part, `s${i}`)}</span>;
  });
}
